import Modal from 'ds/components/modal';
import { useLocale } from 'locale';
import React, { useEffect } from 'react';
import { ActionsWrapper, SubmitButton } from './styled';
import ShieldLockIcon from 'assets/svg/shield-lock-blue.svg';
import { H3, Text } from 'ds/components/typography';
import { ModalContent, ModalIconWrapper, ModalTitle } from '../shared/modal-styles';
import { useSendEvent } from 'analytics/useSendEvent';

interface EnhanceSearchModalProps {
  onClose: () => void;
  isDesktop?: boolean;
}

const EnhanceSearchModal: React.FC<EnhanceSearchModalProps> = ({ onClose, isDesktop }) => {
  const { t } = useLocale();
  const sendEvent = useSendEvent();

  useEffect(() => {
    sendEvent('popup_exposed', 'popup', {
      event: {
        source: 'market_place',
        type: 'saved_search_be_specific',
      },
    });
  }, []);

  const handleClose = () => {
    sendEvent('popup_close', 'popup', {
      event: {
        source: 'market_place',
        type: 'saved_search_be_specific',
      },
    });
    onClose();
  };

  return (
    <Modal
      desktopModalPositionCenter={isDesktop}
      mobileModalPositionBottom={!isDesktop}
      isOpen
      hideCloseButton
      onClose={handleClose}
      contentWrapperStyle={{
        ...(isDesktop ? {
          maxWidth: 402,
        } : {}),
      }}
    >
      <ModalContent>
        <ModalIconWrapper>
          <ShieldLockIcon />
        </ModalIconWrapper>
        <ModalTitle>
          <H3 weight="bold">{t('enhanceSearchModal.title')}</H3>
          <Text>{t('enhanceSearchModal.subtitle')}</Text>
        </ModalTitle>
        <ActionsWrapper>
          <SubmitButton size="extraLarge" onClick={handleClose}>{t('enhanceSearchModal.submit')}</SubmitButton>
        </ActionsWrapper>
      </ModalContent>
    </Modal>
  );
};

export default EnhanceSearchModal;
